import {
    REQUEST_ORDER_DETAIL,
    REQUEST_ORDER_DETAIL_FAILURE,
    REQUEST_ORDER_DETAIL_SUCCESS
} from "../../../constant/transaction/OrderDetailContant";


const initialState = {
    orderDetail: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const orderDetailReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case REQUEST_ORDER_DETAIL:
            return {
                ...state,
                orderDetail: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ORDER_DETAIL_SUCCESS:
            return {
                ...state,
                orderDetail: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ORDER_DETAIL_FAILURE:
            return {
                ...state,
                orderDetail: {
                    data: [],
                    status: 'fetching',
                    isLoading: false,
                },
            };
        default:
            return state;
    }
}
